export const content = `There are a few ways to start psychiatry or medication management. Booking your consultation depends on a few factors, including whether you’ve already created a BetterHelp account and have started therapy with us.

## Booking with an account

You can set up a psychiatric consultation in 3 ways:

- Ask your therapist for a referral
- Complete your symptom questionnaires that you receive in your email
- Contact us at [help@joinuplift.co](mailto:help@joinuplift.co)

## Booking without an account

You can book a consultation during the matching process. After a few initial questions, we’ll ask you **What type of care are you seeking?**

Select **Medication Management** to just book a psychiatric consultation or **Both** if you also want to start talk therapy.

![](https://lh7-rt.googleusercontent.com/docsz/AD_4nXcdTEGTgaTzL9lBD9xVXYe6km6qRgjwri1nE-KXmySd_O7EElMROXU2NSS1LpqgC91z3jWQopm5-3S48VM88Kb5WMofLnVaoUcVbF7qvdp4M__MNMa-bIaR8bR9fvpw0i84IbGXgQ?key=VtL8rUtxDsPjOX4EA8jD-Fpd)
`;
